export default __webpack_public_path__ + "static/media/Diviner's Belt of the Dark Pact.e43110db.jpg";